<template>
  <v-row>
    <v-col cols="12" v-if="!file">
      <div
        @drag.stop.prevent=""
        @dragover.stop.prevent=""
        @dragstart.stop.prevent="startDrag"
        @dragenter.stop.prevent="startDrag"
        @dragend.stop.prevent="stopDrag"
        @dragleave.stop.prevent="stopDrag"
        @drop.stop.prevent="handleDrop"
      >
        <v-file-input
          v-model="file"
          :placeholder="placeholder"
          prepend-icon=""
          outlined
          class="base-input-file__content"
        />
      </div>
    </v-col>
    <v-col cols="12" v-else>
      <BaseDataTable
        :headers="header"
        :items="listFile"
        class="base-input-file__datatable"
        hide-default-footer
      >
        <template v-slot:[`item.name`]="{ item }">
          <div class="d-flex align-center">
            <v-icon class="pr-3" color="primary">
              fa-file
            </v-icon>
            {{ item.name }}
          </div>
        </template>
        <template v-slot:[`item.file`]>
          <BaseButton
            color="secondary"
            class="base-input-file__button mr-2 px-0"
            @click="previewFile"
          >
            <img :src="require('@/assets/ic_eye.svg')" />
          </BaseButton>
          <BaseButton
            color="secondary"
            class="base-input-file__button px-0"
            @click="removeFile"
          >
            <img :src="require('@/assets/ic_trash.svg')" />
          </BaseButton>
        </template>
      </BaseDataTable>
    </v-col>
  </v-row>
</template>
<script>
const tableHeaders = [
  { text: "Imagem adicionada", value: "name", sortable: false },
  { text: "Ações", value: "file", sortable: false }
];
const canDragAndDrop = (() => {
  const div = document.createElement("div");
  return "draggable" in div || ("ondragstart" in div && "ondrop" in div);
})();
export default {
  data: () => ({
    file: null,
    listFile: [],
    header: tableHeaders,
    isDragging: false
  }),
  created() {
    this.file = this.item;
  },
  methods: {
    startDrag() {
      this.isDragging = !canDragAndDrop;
    },
    stopDrag() {
      this.isDragging = false;
    },
    handleDrop(e) {
      this.stopDrag();
      this.file = e.dataTransfer.files[0];
    },
    removeFile() {
      this.listFile = [];
      this.file = null;
    },
    previewFile() {
      const src =
        typeof this.listFile[0].file === "string"
          ? this.listFile[0].file
          : URL.createObjectURL(this.listFile[0].file);
      window.open(src);
    }
  },
  props: {
    item: {
      type: [String, File, Object],
      default: null
    },
    placeholder: {
      type: String,
      default: "Arraste ou clique aqui para adicionar imagem"
    }
  },
  watch: {
    file(value) {
      this.listFile = value
        ? value.name
          ? [{ file: value, name: value.name }]
          : [{ file: value.url, name: value.nome }]
        : [];
      this.$emit("update", value);
    }
  }
};
</script>
<style lang="sass">
.base-input-file__
  &content
    height: 110px
    .v-input__slot
      height: 110px
      fieldset
        border: 1px dashed #D5D5E0 !important
        border-radius: 2px !important
        background-color: #FFFFFF !important
        height: 110px
      .v-file-input__text--placeholder
        justify-content: center
  &button
    min-width: 40px !important
  &datatable
    tbody tr td:last-child
      text-align: end !important
    thead tr th:last-child
      text-align: end !important
</style>
